import Pagination from "components/Pagination";
import { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getConditionData } from "services/_conditions";
import Plusshape from "../../assets/images/Plusshape.png";
import Stethoscope from "../../assets/images/Stethoscope.png";
import rightArrow from "../../assets/images/right-arrow.svg";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Condition = ({ isPagination }) => {
  const [conditionData, setConditionData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const getInitialData = useCallback(async () => {
    try {
      const data = await getConditionData(`page=${page}&per_page=${perPage}`);
      if (data?.data) {
        setRecords(data.data.records || []);
        setConditionData(data.data.records);
        setTotalRecords(data.data.total_records || 0);

        if (data.data.total_records && perPage) {
          setTotalPages(Math.ceil(data.data.total_records / perPage));
        }
      }
    } catch (err) {
      console.error("Error fetching conditions:", err);
    }
  }, [page, perPage]);

  useEffect(() => {
    getInitialData();
  }, [getInitialData]);

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };


  return (
    <>
      <section className="py-[10px] pb-[20px] relative condition ">
        <img
          src={Plusshape}
          alt=""
          className="absolute left-0 top-[-70px] w-[300px] md:block hidden "
        />
        <img
          src={Plusshape}
          alt=""
          className="absolute right-0 bottom-[-70px] w-[300px] "
        />
        <img
          src={Stethoscope}
          alt=""
          className="absolute w-[150px] right-[20px] top-[-120px] md:block hidden "
        />

        <div className="container">
          <div className="flex justify-center">
            <h1 className="heading">Spondyloarthritis conditions</h1>
          </div>
          <div className="flex grid_box mt-[10px] flex-wrap gap-[35px] mt-[20px] justify-center">
            {conditionData.length > 0 ? (
              conditionData.map((val, i) => {
                const imageUrl = `${BACKEND_URL}${val.image_url}`;

                return (
                  <>
                    <div className="condion_box  flex flex-col min-h-[343px] overflow-hidden bg-white max-w-[408px] relative w-full rounded-[15px] ">
                     
                      <div
                        className="icon_box ml-auto w-full relative flex justify-center items-center h-[300px] rounded-full "
                       
                      >
                        <img
                          className=" mx-auto w-full h-full "
                          src={imageUrl}
                          alt=""
                        />
                      </div>
                      <div className="condition_content p-[20px] flex flex-col justify-between h-full   relative">
                        <div>
                          <h2 className="text-[18px] mb-[7px]  font-[700] text-[#000D44] ">
                            {val.name}
                          </h2>
                          <p className="text-[15px] mb-[15px]  line-clamp-2 font-[500] text-[#000D44]">
                            {val.short_description}
                          </p>
                        </div>
                       
                      </div>

                       <div className="flex justify-end">
                          <button
                            className="font-[400] !rounded-tr-none !rounded-bl-none rounded-[5px] p-[7px] px-[12px] bg-[#1F2B6C] text-white "
                           
                            onClick={() =>
                              navigate(`/conditions/view-conditions/${val.id}`)
                            }
                          >
                            <div class="button_box w-[39px] flex justify-center rounded-[3px] items-center h-[30px] bg-white ">
                              <img src={rightArrow} alt="" class="invert-1 w-[22px]"/></div>
                          </button>
                        </div>
                    </div>
                  </>
                );
              })
            ) : (
              <>
                <h1 className="text-center">No Data found</h1>
              </>
            )}
          </div>
          {isPagination && (
            <div className="md:py-[20px] py-[10px]">
              <Pagination
                page={page}
                perPage={perPage}
                totalRecords={totalRecords}
                totalPages={totalPages}
                records={records}
                prevButton={prevButton}
                nextButton={nextButton}
              />
            </div>
          )}
        </div>

        {
          !isPagination &&  <div className="flex justify-center mt-[50px] mb-[20px]">
            <NavLink
              to="/survey"
              className="pain_survey_btn hover:!text-white !text-white !bg-[#1F2B6C]  "
            >
              Take A-Tool&copy; Back Pain survey
              <div className="arrow_icon !bg-white  flex justify-center items-center ">
                <img src={rightArrow} className="w-[30px] invert" alt="" />
              </div>
            </NavLink>
          </div>
        }

         
      </section>
    </>
  );
};
export default Condition;
